/**
 * Who sent an application in, written out as one line.
 *
 * The three parts answer the three questions a reader has - who, for whom and
 * in which capacity - and any missing part simply drops out of the sentence.
 *
 * @param {{name: string, organization: string, role: string}|null} submitter
 */
export const describeSubmitter = (submitter) => {
  if (!submitter || !submitter.name) return null;

  return [submitter.name, submitter.organization, submitter.role].filter(Boolean).join(' - ');
};

/**
 * The same three parts, shortened for a table cell: the organisation drops to
 * its initials, which is what fits next to a name and a role in one column.
 *
 * @param {{name: string, organizationInitials: string, organization: string, role: string}|null} submitter
 */
export const describeSubmitterShort = (submitter) => {
  if (!submitter || !submitter.name) return null;

  const organization = submitter.organizationInitials || submitter.organization;

  return [submitter.name, organization, submitter.role].filter(Boolean).join(' / ');
};

export default describeSubmitter;
